import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import PanoPlayer, { HotspotEditEvents, ControlEvents, eventBus} from 'PanoPlayerSDK'
import HttpUrl from '@ali/lib-httpurl'
import { getPanos } from './Api'

import Menu from './Components/Menu'
import Scroll from './Components/Scroll'
import Modal from './Components/Modal'
import Loading from './Components/Loading'
import Goods from './Components/Goods'

import {
  nativeBack,
  showShare,
  isInBrowser,
  loadImage,
  timeoutPromise,
  getDeviceInfo,
  Toast
} from './Util'

import './App.css'

class App extends Component {
  state = {
    isIphoneX: false,
    sellerId: '',
    panos: [],
    shoppingList: [],
    thumbnail: '',
    scrollVisible: false,
    modalVisible: false,
    loadingVisible: true,
    loadingProcess: 0,
    itemInfo: null,
    hideMenuIcon: false
  }
  constructor(props) {
    super(props)

    this.panoPlayer = null
    this.httpUrl = new HttpUrl(window.location.href)
    
    this.init()
    this.detectIsIPhoneX().then(isIphoneX => this.setState({ isIphoneX }))
  }

  init = () => {
    let { token, materialId, hideIcon } = this.httpUrl.params
    this.state.hideMenuIcon = hideIcon === 'true'
    // this.setState({ hideMenuIcon: hideIcon === 'true' })
    getPanos(token).then(res => {
      let resData = res.data || {}
      let result = resData.data || {}
      let { data: { panos = [], nick, owner, title, thumbnail, shoppingList = [] } = {} } = result
      if (materialId) {
        panos = panos.filter(v => v.id === materialId)
      }
      if (!panos.length) {
        Toast('无数据')
        return
      }
      this.setState({ panos, sceneName: title, thumbnail, shoppingList, sellerId: owner, sellerNick: nick })
      const LoadingTimeline = [0.45, 0.99]
      const p = () => {
        return new Promise(resolve => {
          let i = 0
          let processTimer = -1
          const stepProcess = () => {
            clearTimeout(processTimer)
            processTimer = setTimeout(() => {
              i++
              let process = LoadingTimeline[i]
              if (process) {
                stepProcess()
                if (i === LoadingTimeline.length - 1) {
                  resolve()
                }
              }
            }, 1000)
            this.setState({ loadingProcess: LoadingTimeline[i] })
          }
          stepProcess()
        })
      }
      const loadBackgroundImage = () => {
        return !!thumbnail ? loadImage(thumbnail) : Promise.resolve()
      }
      loadBackgroundImage()
        .then(() => p())
        .then(() => {
          this.panoPlayer = new PanoPlayer(panos, document.getElementById('canvas'), { autoRotate: true })
        })
    }, err => {
      Toast('加载失败')
      console.log(err) // eslint-disable-line
    })
  }

  loadPanorama = (id) => {
    return this.panoPlayer.load(id)
  }

  showModalWithPayload = (type, { data }) => {
    if (type === 'item') {
      this.setState({
        modalVisible: true,
        itemInfo: data
      })
    }
  }

  hideModal = (type) => {
    if (type === 'item') {
      this.setState({
        modalVisible: false,
        itemInfo: null
      })
    }
  }

  toggleScroll = () => {
    this.setState(({ scrollVisible }) => ({
      scrollVisible: !scrollVisible
    }))
  }

  locateHotspot = (tagId, itemInfo) => {
    eventBus.dispatchEvent({ type: ControlEvents.TagAnimate, data: { tagId } })
    timeoutPromise(800).then(() => this.showModalWithPayload('item', { data: itemInfo }))
  }

  handleShareClk = () => {
    console.log('share')
    showShare('introCard.title', "我正穿越时空进入xxx，和我一起来逛吧~", '//img.alicdn.com/tfs/TB1EJisbeuSBuNjSsplXXbe8pXa-512-512.png', window.location.href)
  }
  
  handleBackClk = () => {
    nativeBack()
  }

  detectIsIPhoneX = () => {
    return getDeviceInfo()
      .then(e => {
        if (e.platform && e.platform.match(/iPhone/)) {
          let gen = (e.platform.split(',')[0].split('iPhone')[1]) * 1
          return gen === 10
        }
        return false
      })
  }

  componentDidMount() {
    eventBus.addEventListener(HotspotEditEvents.ClickHotspot, ({ data = {} }) => {
      let { tag = {} } = data || {}
      let { itemId, itemInfo } = tag
      itemInfo = { ...itemInfo, itemId }
      if (itemInfo) {
        this.showModalWithPayload('item', { data: itemInfo })
      }
    })

    eventBus.addEventListener(ControlEvents.PanoPlayerLoad, () => {
      this.setState({
        loadingProcess: 1
      })
      timeoutPromise(300).then(() => {
        this.setState({
          loadingVisible: false
        })
      })
    })

    window.addEventListener('resize', () => {
      console.log('resize')
      if (this.panoPlayer) {
        this.panoPlayer.handleResize()
      }
    }, false)
    /* eventBus.addEventListener(ControlEvents.PanoPlayerEntranceAnimateEnd, () => {
      this.setState({
        scrollVisible: true
      })
    }) */
  }

  render() {
    let { isIphoneX, sellerId, sellerNick, sceneName, panos, thumbnail, shoppingList, hideMenuIcon, scrollVisible, modalVisible, loadingVisible, loadingProcess, itemInfo } = this.state
    let iPhoneXCls = isIphoneX ? 'iphonex' : ''
    return (
      <div className={`gui-container ${iPhoneXCls}`}>
        {!isInBrowser && <div className="back" onClick={this.handleBackClk} />}
        {!isInBrowser && <div className="share" onClick={this.handleShareClk} />}
        {!hideMenuIcon && <Menu sellerId={sellerId} sellerNick={sellerNick} toggleScroll={this.toggleScroll} scrollVisible={scrollVisible} />}
        {!!shoppingList.length && <Goods shoppingList={shoppingList} locateHotspot={this.locateHotspot} />}
        {!hideMenuIcon && scrollVisible && <Scroll toggleScroll={this.toggleScroll} panos={panos} loadPanorama={this.loadPanorama}></Scroll>}
        {modalVisible && <Modal item={itemInfo} hideModal={() => this.hideModal('item')} />}
        {loadingVisible && <Loading process={loadingProcess} sceneName={sceneName} thumbnail={thumbnail} />}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js